<div class="booking-status-label uppercase flex align-center" [ngClass]="statusClass">
  {{ statusTitle }}
</div>
